import { render } from "./ArqComponent.vue?vue&type=template&id=0be5f406&scoped=true"
import script from "./ArqComponent.vue?vue&type=script&lang=js"
export * from "./ArqComponent.vue?vue&type=script&lang=js"

import "./ArqComponent.vue?vue&type=style&index=0&id=0be5f406&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be5f406"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QLayout from 'quasar/src/components/layout/QLayout.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QLayout});
